import React from 'react';
import NavBar from './NavBar';
import Footer from './Footer';

const Layout = ({ children }) => {
    return (
        <div className="flex flex-col min-h-screen">
            {/* Skip to main content link - visible only when focused */}
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-niwy-primary focus:text-white focus:rounded-md focus:outline-none focus:ring-2 focus:ring-niwy-accent"
            >
                Przejdź do treści głównej
            </a>
            <NavBar />
            <main id="main-content" className="flex-grow pt-20" role="main">
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
